(function () {
    function initSlrFaq(section) {
      if (!section) return;

      var questions = section.querySelectorAll('.slr-faq__question');

      questions.forEach(function (question) {
        if (question.dataset.slrFaqReady === 'true') return;
        question.dataset.slrFaqReady = 'true';

        question.addEventListener('click', function () {
          var answer = question.nextElementSibling;
          if (!answer || !answer.classList.contains('slr-faq__answer')) return;

          var isOpen = question.getAttribute('aria-expanded') === 'true';

          question.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          answer.hidden = isOpen;
          answer.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
        });
      });

      var navLinks = section.querySelectorAll('[data-slr-scroll]');

      navLinks.forEach(function (link) {
        if (link.dataset.slrScrollReady === 'true') return;
        link.dataset.slrScrollReady = 'true';

        link.addEventListener('click', function (event) {
          var targetSelector = link.getAttribute('href');
          if (!targetSelector || targetSelector.charAt(0) !== '#') return;

          var target = section.querySelector(targetSelector);
          if (!target) return;

          event.preventDefault();

          var header = document.querySelector('.shopify-section-header-sticky, .header-wrapper, .section-header');
          var headerHeight = header ? header.getBoundingClientRect().height : 0;
          var offset = headerHeight + 58;
          var targetTop = window.pageYOffset + target.getBoundingClientRect().top - offset;

          window.scrollTo({
            top: targetTop,
            behavior: 'smooth'
          });
        });
      });
    }

    function initAll(scope) { (scope || document).querySelectorAll('[data-slr-faq]').forEach(initSlrFaq); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { initAll(document); }); else initAll(document);
    document.addEventListener('shopify:section:load', function(event) { initAll(event.target); });
  })();
